import Cookies from 'vue-cookies'
const TokenKey = 'token'
const accountKey = 'account'
const passwordKey = 'password'
const isSaveKey = 'isSave'

export function getToken() {
  // eslint-disable-next-line no-undef
  return Cookies.get(TokenKey)
}

export function setToken(token) {
  // eslint-disable-next-line no-undef
  return Cookies.set(TokenKey, token)
}

export function removeToken() {
  // eslint-disable-next-line no-undef
  return Cookies.remove(TokenKey)
}

export function getAccount() {
  // eslint-disable-next-line no-undef
  return Cookies.get(accountKey)
}

export function setAccount(account) {
  // eslint-disable-next-line no-undef
  return Cookies.set(accountKey, account)
}

export function getPassword() {
  // eslint-disable-next-line no-undef
  return Cookies.get(passwordKey)
}

export function setPassword(password) {
  // eslint-disable-next-line no-undef
  return Cookies.set(passwordKey, password)
}

export function getIsSave() {
  // eslint-disable-next-line no-undef
  return Cookies.get(isSaveKey)
}

export function setIsSave(isSave) {
  // eslint-disable-next-line no-undef
  return Cookies.set(isSaveKey, isSave)
}

// 是否拥有权限
export function hasPermission(fullPath) {
  let path = getPath(fullPath)
  let query = getParamObject(fullPath);
  // 判断是否有权限
  let menuList = JSON.parse(localStorage.getItem("menu"));
  if (menuList && menuList.length > 0) {
    for (let menu of menuList) {
      // 地址一样
      if (menu.split("?")[0] == path) {
        // 判断参数
        let paramObject = getParamObject(menu);
        let isCheck = true;
        Object.keys(paramObject).forEach(key => {
          if (paramObject[key] != query[key]) {
            isCheck = false;
          }
        });
        if (isCheck) {
          return true;
        }
      }
    }
  }
  return false;
}

// 获取地址
function getPath(fullPath) {
  return fullPath.split("?")[0]
}

// 获取参数
function getParamObject(fullPath) {
  let paramObject = [];
  if (fullPath.split("?").length < 2) {
    return [];
  }
  let paramStr = fullPath.split("?")[1];
  let params = paramStr.split("&");
  params.forEach(item => {
    let param = item.split("=");
    if (param.length > 1) {
      paramObject[param[0]] = param[1]
    }
  });
  return paramObject;
}



// WEBPACK FOOTER //
// ./src/utils/auth.js